export enum StandardCRMItemHistoryEventType {
  NOTE = 'NOTE',
  COMPANY = 'COMPANY',
  GROUP = 'GROUP',
  LEADER = 'LEADER',
  PARTICIPANT = 'PARTICIPANT',
  STATUS = 'STATUS',
  NAME = 'NAME',
  ARCHIVED = 'ARCHIVED',
  STORM = 'STORM',
  ETAKI = 'ETAKI',
  SILENCED_UNTIL = 'SILENCED UNTIL',
  COURTSHIP = 'COURTSHIP',
  AGENDA = 'AGENDA',
  INDICATED = 'INDICATED',
  RECEIVED = 'RECEIVED',
  COURTSHIP_LAST_AFFIRMED = 'COURTSHIP_LAST_AFFIRMED',
}

export enum StructCapItemHistoryEventType {
  NOTE = 'NOTE',
  COMPANY = 'COMPANY',
  GROUP = 'GROUP',
  LEADER = 'LEADER',
  PARTICIPANT = 'PARTICIPANT',
  STATUS = 'STATUS',
  NAME = 'NAME',
  ARCHIVED = 'ARCHIVED',
  STORM = 'STORM',
  ETAKI = 'ETAKI',
  SILENCED_UNTIL = 'SILENCED UNTIL',
  COURTSHIP = 'COURTSHIP',
  AGENDA = 'AGENDA',
  INDICATED = 'INDICATED',
  RECEIVED = 'RECEIVED',
  COURTSHIP_LAST_AFFIRMED = 'COURTSHIP_LAST_AFFIRMED',
  CAP_IQ_ID = 'CAP_IQ_ID',
  TOTAL_DEAL_SIZE = 'TOTAL_DEAL_SIZE',
  RA_DEAL_SIZE = 'RA_DEAL_SIZE',
  PRIORITY = 'PRIORITY',
  DEAL_SOURCE_CONTACT = 'DEAL_SOURCE_CONTACT',
  COMPANY_STAGE = 'COMPANY_STAGE',
  HEALTHCARE_SUBSECTOR = 'HEALTHCARE_SUBSECTOR',
  DISEASE_FOCUS = 'DISEASE_FOCUS',
  LOCATION = 'LOCATION',
  EXPECTED_CLOSING_DATE = 'EXPECTED_CLOSING_DATE',
  REVENUE_MODEL = 'REVENUE_MODEL',
  DOWNSIDE_SUPPORT = 'DOWNSIDE_SUPPORT',
  LTM_REVENUE = 'LTM_REVENUE',
  LTM_EBITDA = 'LTM_EBITDA',
  EXPECTED_IRR = 'EXPECTED_IRR',
  EXPECTED_MOIC = 'EXPECTED_MOIC',
  LAST_ROUND_VALUATION = 'LAST_ROUND_VALUATION',
  CURRENT_ROUND_VALUATION = 'CURRENT_ROUND_VALUATION',
  NDA_SIGNED = 'NDA_SIGNED',
  NDA_EXPIRATION = 'NDA_EXPIRATION',
}

export const StandardCRMItemHistoryEventTypeLabels: Record<StandardCRMItemHistoryEventType, string> = {
  [StandardCRMItemHistoryEventType.NOTE]: 'Note',
  [StandardCRMItemHistoryEventType.COMPANY]: 'Company',
  [StandardCRMItemHistoryEventType.GROUP]: 'Group',
  [StandardCRMItemHistoryEventType.LEADER]: 'Leader',
  [StandardCRMItemHistoryEventType.PARTICIPANT]: 'Participant',
  [StandardCRMItemHistoryEventType.STATUS]: 'Stage',
  [StandardCRMItemHistoryEventType.NAME]: 'Name',
  [StandardCRMItemHistoryEventType.ARCHIVED]: 'Closed',
  [StandardCRMItemHistoryEventType.STORM]: 'Storm',
  [StandardCRMItemHistoryEventType.ETAKI]: 'ETA-KI',
  [StandardCRMItemHistoryEventType.SILENCED_UNTIL]: 'Silenced Until',
  [StandardCRMItemHistoryEventType.COURTSHIP]: 'Courtship',
  [StandardCRMItemHistoryEventType.AGENDA]: 'Agenda',
  [StandardCRMItemHistoryEventType.INDICATED]: 'Indicated',
  [StandardCRMItemHistoryEventType.RECEIVED]: 'Received',
  [StandardCRMItemHistoryEventType.COURTSHIP_LAST_AFFIRMED]: 'Courtship Last Affirmed',
};

export const StructCapCRMItemHistoryEventTypeLabels: Record<StructCapItemHistoryEventType, string> = {
  [StructCapItemHistoryEventType.NOTE]: 'Note',
  [StructCapItemHistoryEventType.COMPANY]: 'Company',
  [StructCapItemHistoryEventType.GROUP]: 'Group',
  [StructCapItemHistoryEventType.LEADER]: 'Leader',
  [StructCapItemHistoryEventType.PARTICIPANT]: 'Participant',
  [StructCapItemHistoryEventType.STATUS]: 'Status',
  [StructCapItemHistoryEventType.NAME]: 'Name',
  [StructCapItemHistoryEventType.ARCHIVED]: 'Closed',
  [StructCapItemHistoryEventType.STORM]: 'Storm',
  [StructCapItemHistoryEventType.ETAKI]: 'ETA-KI',
  [StructCapItemHistoryEventType.SILENCED_UNTIL]: 'Silenced Until',
  [StructCapItemHistoryEventType.COURTSHIP]: 'Courtship',
  [StructCapItemHistoryEventType.AGENDA]: 'Agenda',
  [StructCapItemHistoryEventType.INDICATED]: 'Indicated',
  [StructCapItemHistoryEventType.RECEIVED]: 'Received',
  [StructCapItemHistoryEventType.COURTSHIP_LAST_AFFIRMED]: 'Courtship Last Affirmed',
  [StructCapItemHistoryEventType.CAP_IQ_ID]: 'Cap IQ ID',
  [StructCapItemHistoryEventType.TOTAL_DEAL_SIZE]: 'Total Deal Size',
  [StructCapItemHistoryEventType.RA_DEAL_SIZE]: 'RA Deal Size',
  [StructCapItemHistoryEventType.PRIORITY]: 'Priority',
  [StructCapItemHistoryEventType.DEAL_SOURCE_CONTACT]: 'Deal Source Contact',
  [StructCapItemHistoryEventType.COMPANY_STAGE]: 'Company Stage',
  [StructCapItemHistoryEventType.HEALTHCARE_SUBSECTOR]: 'Healthcare Subsector',
  [StructCapItemHistoryEventType.DISEASE_FOCUS]: 'Disease Focus',
  [StructCapItemHistoryEventType.LOCATION]: 'Location',
  [StructCapItemHistoryEventType.EXPECTED_CLOSING_DATE]: 'Expected Closing Date',
  [StructCapItemHistoryEventType.REVENUE_MODEL]: 'Revenue Model',
  [StructCapItemHistoryEventType.DOWNSIDE_SUPPORT]: 'Downside Support',
  [StructCapItemHistoryEventType.LTM_REVENUE]: 'LTM Revenue',
  [StructCapItemHistoryEventType.LTM_EBITDA]: 'LTM EBITDA',
  [StructCapItemHistoryEventType.EXPECTED_IRR]: 'Expected IRR',
  [StructCapItemHistoryEventType.EXPECTED_MOIC]: 'Expected MOIC',
  [StructCapItemHistoryEventType.LAST_ROUND_VALUATION]: 'Last Round Valuation',
  [StructCapItemHistoryEventType.CURRENT_ROUND_VALUATION]: 'Current Round Valuation',
  [StructCapItemHistoryEventType.NDA_SIGNED]: 'NDA Signed',
  [StructCapItemHistoryEventType.NDA_EXPIRATION]: 'NDA Expiration',
};

export class CRMItemHistory {
  note: string;
  tableId: number;
  eventTimestamp: Date;
  itemId: number;
  eventChangedBy: number;
  eventChangedByName: string;
  eventAction: string;
  eventType: StandardCRMItemHistoryEventType | StructCapItemHistoryEventType;
}
